import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitter,
  faInstagram,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const FifthSection = ({ contactRef, featureScroll }) => {
  return (
    <div
      ref={contactRef}
      className="text-sm md:text-base md:mt-15 relative overflow-hidden bottomFooter"
    >
      <div className="grid grid-cols-3 md:gap-6 p-4 md:p-8 justify-center text-white">
        <div className="flex flex-col">
          <div className="md:text-xl md:mb-4">Useful links</div>
          <div>
            <Link to="/">Home</Link>
          </div>
          <div className="cursor-pointer" onClick={featureScroll}>
            Features
          </div>
          <div>Pricing</div>
        </div>
        <div className="flex flex-col">
          <div className="md:text-xl md:mb-4">Need Help?</div>
          <div>Faqs</div>
          <div>Privacy</div>
          <div>Support</div>
          <div>Terms</div>
        </div>
        <div className="flex flex-col">
          <div className="md:text-xl md:mb-4">Contact</div>
          <div className="mb-1">
            <a href="https://mail.google.com/mail/u/0/?fs=1&to=rohithsuri3@gmail.com&su=Review+on+Counsel&tf=cm">
              <FontAwesomeIcon className="md:text-xl" icon={faEnvelope} />
            </a>
          </div>
          <div className="mb-1">
            <a href="https://twitter.com/minthran_indrum">
              <FontAwesomeIcon className="md:text-xl" icon={faTwitter} />
            </a>
          </div>
          <div className="mb-1">
            <a href="https://www.instagram.com/mithran.indrum/">
              <FontAwesomeIcon className="md:text-2xl" icon={faInstagram} />
            </a>
          </div>
          <div className="mb-1">
            <a href="https://www.facebook.com/mithran.indrum/">
              <FontAwesomeIcon className="md:text-xl" icon={faFacebook} />
            </a>
          </div>
        </div>
      </div>
      <div className="flex justify-center text-white text-sm mb-2">
        <div>
          Designed by -{' '}
          <a
            className="underline italic font-semibold"
            href="https://www.linkedin.com/in/kishore-singh369/"
          >
            Kishore Singh
          </a>
        </div>
      </div>
    </div>
  );
};

export default FifthSection;
